/**
 * Vergleich von Ausgangsstand und Arbeitsstand (Regel „Dokument-Navigation" R5: jede
 * Änderung macht das Dokument „ungespeichert"). Ersetzt die bisher sechs verschiedenen
 * Eigenbauten (Ref-Baseline, JSON-Snapshot, feldweiser Vergleich, Zeilen-Flags …).
 *
 * Reihenfolge der Schlüssel spielt keine Rolle; undefined und fehlender Schlüssel gelten
 * als gleich; Listen werden in ihrer Reihenfolge verglichen.
 */
export function stableStringify(value: unknown): string {
  return JSON.stringify(normalize(value));
}

function normalize(v: unknown): unknown {
  if (v === undefined) return null;
  if (v === null || typeof v !== 'object') return v;
  if (v instanceof Date) return v.toISOString();
  if (Array.isArray(v)) return v.map(normalize);
  const out: Record<string, unknown> = {};
  for (const k of Object.keys(v as Record<string, unknown>).sort()) {
    const n = (v as Record<string, unknown>)[k];
    if (n === undefined) continue;
    out[k] = normalize(n);
  }
  return out;
}

export function isEqualValue(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  return stableStringify(a) === stableStringify(b);
}

/** Schlüssel der obersten Ebene, deren Wert sich geändert hat. */
export function changedKeys<T extends object>(baseline: T, current: T): Array<keyof T> {
  const keys = new Set<string>([...Object.keys(baseline), ...Object.keys(current)]);
  const out: Array<keyof T> = [];
  for (const k of keys) {
    if (!isEqualValue((baseline as Record<string, unknown>)[k], (current as Record<string, unknown>)[k])) out.push(k as keyof T);
  }
  return out;
}
